import { DateTime, Interval } from 'luxon';
import { StartEnd } from 'olo-service';
import { toDateTime } from './merchant/util';

const SCHEDULED_ORDER_KEY_BASE = 'colo-scheduled-order_';

export const scheduledOrderKey = (merchantId: string) => `${SCHEDULED_ORDER_KEY_BASE}${merchantId}`;

export const getDateLabel = (date : DateTime) => {
    let label;
    switch (date.toRelativeCalendar()) {
      case 'today':
        label = 'scheduledOrder.today';
        break;
      case 'tomorrow':
        label = 'scheduledOrder.tomorrow';
        break;
      default:
        label = 'scheduledOrder.futureDate';
    }

    return label;
};

export const canScheduleOrderToday = (todaysHours : StartEnd[] | undefined, now: DateTime, timezone: string, leadTime: number | undefined) => {
  if (!todaysHours) return false;

  return todaysHours.flatMap(hours => {
    const startTime = toDateTime(hours.start, timezone);
    const endTime = toDateTime(hours.end, timezone);

    const interval = Interval.fromDateTimes(startTime, endTime);

    if (interval.isBefore(now)) return false;
    if (interval.isAfter(now)) return true;
    if (interval.contains(now)) return interval.contains(now.plus({ minutes: leadTime }));

    return false;

  }).includes(true);
};
